export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14220.476ca615.jpg";